import React, { useState, MouseEvent } from "react";
import { IconButtonProps, IconButton, CircularProgress, Dialog, DialogTitle, DialogActions, Button, DialogContent, DialogContentText } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { green } from "@material-ui/core/colors";


const useStyle = makeStyles({
  buttonProgress: {
    color: green[500],
    position: 'absolute',
  },
});


export default function LoadingButton(props: IconButtonProps & { pending?: boolean, confirm?: string }) {
  const classes = useStyle();
  const { children, pending, disabled, confirm, onClick, ...rest } = props;

  const [open, setOpen] = useState(false);
  const handleClose = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen(false);
  }
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (!onClick) {
      return;
    }
    if (!confirm) {
      return onClick(e);
    }
    setOpen(true);
  }
  const handleConfirm = (e: MouseEvent<HTMLButtonElement>) => {
    if (!onClick) {
      return;
    }
    onClick(e);
    handleClose(e);
  }

  return (
    <IconButton {...rest} disabled={disabled || pending} onClick={handleClick}>
      {children}
      {pending && <CircularProgress className={classes.buttonProgress} />}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {confirm}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} color="primary">
            Ok
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </IconButton>
  )
}